import { Eye, EyeOff } from 'lucide-react';
import { useState } from 'react';

import { CopyButton } from '../shared/CopyButton';

import { maskedPassCode } from './gift-passes-model';

const CODE_STYLE = {
  fontWeight: 700,
  color: 'var(--nb-ink)',
  letterSpacing: '.05em',
  overflowWrap: 'anywhere',
} as const;

/** The full code is on the page only when the viewer may see it; others get no controls. */
export function GiftPassCodeReveal({
  code,
  codeMasked,
}: {
  code: string | null;
  codeMasked: string;
}) {
  const [revealed, setRevealed] = useState(false);
  const shown = revealed && code ? code : maskedPassCode(codeMasked);
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        flexWrap: 'wrap',
        minWidth: 0,
        fontSize: 17,
      }}
    >
      <span className="nb-mono" style={CODE_STYLE} aria-live="polite">
        {shown}
      </span>
      {code && (
        <button
          type="button"
          className="nb-btn nb-btn-ghost"
          onClick={() => setRevealed((r) => !r)}
          aria-pressed={revealed}
          style={{ height: 26, padding: '0 8px', gap: 5, fontSize: 12 }}
        >
          {revealed ? <EyeOff size={14} aria-hidden /> : <Eye size={14} aria-hidden />}
          {revealed ? 'Hide' : 'Show'}
          <span className="nb-sr-only"> full code</span>
        </button>
      )}
      {code && revealed && <CopyButton value={code} what="pass code" />}
    </div>
  );
}
